// variables
import { themeOptions } from 'variables';

// libraries
import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledDialogModal = styled(Modal)`
  .ant-modal-close {
    width: 40px;
    height: 40px;
    top: 14px;
    bottom: 14px;
    right: 22px;

    img {
      width: 24px !important;
      height: 24px !important;
    }
  }

  .ant-modal-header {
    background-color: ${themeOptions.palette.mainColor};
    padding: 20px 28px;

    > .ant-modal-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 23.87px;
      color: #ffffff;
    }
  }

  .ant-modal-body {
    padding: 1.4rem 1.8rem 28px 28px;
  }

  .ant-modal-footer {
    padding: 8px 28px 28px 28px;
    display: flex;
    justify-content: ${({ is_flex_end }) => (is_flex_end ? 'flex-end' : 'space-between')};
    /* display: none !important; */
  }
`;
